import venezuelaFlag from "./venezuela.png";
import refresh from './refresh.png';
import helpButton from './helpButton.png';
import backButton from './backButton.png';
import React, { useEffect, useState, useMemo, useRef } from "react";
import { collection, getDoc, getDocs, setDoc, doc, updateDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { database, storage } from "./firebase";
import { UserAuth } from "./context/AuthContext";
import { ref, getDownloadURL } from "firebase/storage";

function TeacherCheckWords() {
    const {user} = UserAuth();
    const [input, setInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentNumber, setCurrentNumber] = useState(1);
    const [imageUrl, setImageUrl] = useState(null);
    const [loadingImage, setLoadingImage] = useState(true);
    const [showModalTip, setShowModalTip] = useState(false);

    useEffect(() => {
        // Проверяем, что currentNumber установлен
        if (!currentNumber) return;

        const fetchImage = async () => {
          setLoadingImage(true);
          try {
            const imagePath = `wordImages/wordID_${currentNumber}.jpeg`; // Генерация пути к изображению
            const imageRef = ref(storage, imagePath);
            const url = await getDownloadURL(imageRef);
            setImageUrl(url);
            // console.log(url)
          } catch (error) {
            console.error("Ошибка при загрузке изображения:", error);
          } finally {
            setLoadingImage(false);
          }
        };
    
        fetchImage();
        
    }, [currentNumber]);

    var countryOfTeacher = "";
    var flag = "";
    var currentCountry = "";

    if (user.uid === "ZVizQP2LHAduZzKOyAMjmhJ69d03"){
        countryOfTeacher = "VenezuelaTeacherStats";
        flag = venezuelaFlag;
        currentCountry = "Venezuela"
    } else {
        countryOfTeacher = "";
        currentCountry = "";
    }

    const pathToTheBase = collection(database, "Words");
    const pathToTheProgress = doc(database, "teachers", user.uid);

    //Загружаем данные один раз при монтировании компонента
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                
                // Запрос данных из wordsTest
                const dbData = await getDocs(pathToTheBase);
                const receivedData = dbData.docs.map(doc => ({ ...doc.data(), id: doc.id }));
                setData(receivedData);
                // console.log(receivedData)

                // Запрос текущего номера слова из solarUpdates
                const dbProgress = await getDoc(pathToTheProgress);
                const lastCheckedWord = dbProgress.exists() ? dbProgress.data().lastCheckedWord : "";
                setCurrentNumber(lastCheckedWord);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // Мемоизация текущего слова на основе currentNumber
    const currentWord = useMemo(() => {
        return data.find(word => word.id === `wordID_${currentNumber}`);
    }, [data, currentNumber]);

    // Функция для обновления currentNumber и получения следующего слова
    const getNextWord = () => {
        hadleCheckWord();
        const nextNumber = parseInt(currentNumber) + 1;
        setCurrentNumber(nextNumber.toString());
    };

    // Функция для обновления currentNumber и получения предыдущего слова
    const getPreviousWord = () => {
        // hadleCheckWord();
        const previousNumber = parseInt(currentNumber) - 1;
        setCurrentNumber(previousNumber.toString());
    };

    // Функция для отображения поля ввода
    const showInput = () => {
        const inputDiv = document.getElementById("inputAndButton");
        inputDiv.classList.toggle("hidden");
    };

    if (isLoading) {
        return <p>Loading...</p>;
    };

    let article = '';
    if (currentWord !== undefined) {
        if(currentWord.type === 'noun'){
            if(currentWord.gender === 'm'){
                article = 'el';
            }else if(currentWord.gender === 'f'){
                article = 'la';
            }else if(currentWord.gender === 'm(pl)'){
                article = 'los';
            }else if(currentWord.gender === 'f(pl)'){
                article = 'las';
            }else if(currentWord.gender === 'f(el)'){
                article = 'el';
            }else{
                console.log('error in article')
            };
        };
    }

    const hadleCheckWord = async (e) => {
        // e.preventDefault();
        const currentDate = Timestamp.now(); // Текущая дата в формате Timestamp
        await setDoc(doc(database, "CheckedWords", "word_"+currentNumber+"_"+currentCountry), {
            word: currentWord.wordOrPhrase,
            isTheSame: input === "" ? true : false,
            anotherWord: input,
            id: parseInt(currentNumber),
            teacherCountry: currentCountry,
            teacherID: user.uid,
            dateChecked: currentDate // Сохраняем как Timestamp
        });
        await updateDoc(pathToTheProgress, {
            lastCheckedWord: parseInt(currentNumber)+1,
            checkedWordsArray: arrayUnion(parseInt(currentNumber)) // добавляем currentNumber в массив
        });
        setInput("");
    };

    const toggleModalTip = () => {
        setShowModalTip(prevState => !prevState);
    };
    
    return (
        <div className="flex flex-col justify-center items-center">
            <div className="flex flex-row items-center">
                <button onClick={getPreviousWord}>
                    <img className="h-10 px-4" src={backButton} />
                </button>
                <img className="h-16 px-4" src={flag} />
                <h2 className="text-2xl">{currentCountry}</h2>
                {/* <button><img className="h-12 px-4" src={refresh} /></button> */}
                <button onClick={toggleModalTip}>
                    <img className="h-10 px-4" src={helpButton} />
                </button>
            </div>
            
            {currentWord ? (
                <div className="text-center">
                    {loadingImage ? "Imagen esta cargando..." :
                        <img className="h-56 w-56 border-2 rounded-2xl" src={imageUrl} alt={currentWord.wordOrPhrase} />
                    }
                    <p className="text-2xl">{article + " "+currentWord.wordOrPhrase}</p>
                    <p>{currentWord.engTranslation.join(", ")}</p>
                    <p>{currentWord.rusTranslation.join(", ")}</p>
                </div>
            ) : (
                <p>Ha habido un error. Vuelva a intentarlo más tarde.</p>
            )}
            <div className="sm:space-x-4 flex flex-col-reverse items-center gap-y-1 sm:gap-y-0 sm:flex-row">
                <button onClick={showInput} className="hover:shadow-lg px-3 py-2 mt-0 text-2xl text-center bg-violet-500 text-white font-black rounded-full">Es la otra palabra↓</button>
                <button onClick={getNextWord} className="hover:shadow-lg px-3 py-2 mt-0 text-2xl text-center bg-amber-500 text-white font-black rounded-full">{input === "" ? "Es la misma palabra→" : "Enviar"}</button>
            </div>
            <div className="w-full px-5 mt-4 flex flex-col items-end hidden" id="inputAndButton">
                <input value={input} onChange={(e) => setInput(e.target.value)} className="text-center appearance-none w-full block bg-white text-gray-700 border border-gray-500 rounded-xl py-3 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" type="text" placeholder=""></input>
                {/* <button className="mt-4 hover:shadow-lg px-3 py-2 mt-0 text-2xl text-center bg-green-500 text-white font-black rounded-lg">Done</button> */}
            </div>
            {/* Модальное окно подсказка */}
            {showModalTip && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="relative flex flex-col w-3/4 xl:w-1/2 bg-white p-4 rounded-md mb-4 text-sm">
                    {/* Кнопка закрытия */}
                    <button
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
                    onClick={toggleModalTip}
                    >
                    ✖
                    </button>
                    <p>
                    Importante: debe indicarnos si esta palabra concreta se utiliza en su país con el mismo significado. En caso afirmativo, haga clic en el botón «Es la misma palabra». Si NO se utiliza en este sentido, haga clic en «Es la otra palabra» y aparecerá un campo en la parte inferior para introducir la palabra. Introduzca la palabra con el artículo (para el sustantivo) en este campo y haga clic en «Enviar».
                    </p>
                    <p className="text-center">- - -</p>
                    <p>
                    Incluso si la palabra se utiliza con el mismo significado en su país pero con un artículo diferente, haga clic en «Es la otra palabra» e introduzca la palabra con el artículo correcto en el campo.
                    </p>
                </div>
                </div>
            )}
        </div>
    )
}

export default TeacherCheckWords